import React, { useEffect, useState } from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "../EmployeeSection/Employeewithdraw.css";
import Base from "../admin_components/Admin_Base";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Breadcrumbs } from "@mui/material";
import Link from "@mui/material/Link";
import authAxios from "../Auth/useAxios";
import { ADMIN_API_BASE_URL } from "../Auth/Api";
import { ClipLoader } from "react-spinners";

const EmployeeWalletWithdrawrequest = () => {
  const [filterStatus, setFilterStatus] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [incentiveList, setIncentiveList] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "requestDate",
    direction: "desc",
  });
  const itemsPerPage = 25;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchIncentiveWithdrawRequestList();
  }, []);

  const fetchIncentiveWithdrawRequestList = async () => {
    try {
      const response = await authAxios.get(
        `${ADMIN_API_BASE_URL}/main/admin/incentive-withdraw-requests/all`
      );
      setIncentiveList(response.data);
    } catch (error) {
      console.error("❌ Error fetching all employees:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      const response = await authAxios.put(
        `${ADMIN_API_BASE_URL}/main/admin/incentive-status/${id}`,
        null,
        { params: { status: newStatus } }
      );

      if (response.status === 200) {
        alert(`✅ Transaction ${newStatus.toUpperCase()} successfully!`);
        await fetchIncentiveWithdrawRequestList();
      }
    } catch (error) {
      console.error(`❌ Error updating transaction status:`, error);
      alert(`❌ Failed to update status. Try again.`);
    }
  };

  const handleApprove = (transactionId) => {
    if (window.confirm("Are you sure you want to approve this request?")) {
      handleStatusChange(transactionId, "APPROVED");
    }
  };

  const handleReject = (transactionId) => {
    if (window.confirm("Are you sure you want to reject this request?")) {
      handleStatusChange(transactionId, "REJECTED");
    }
  };

  // Sorting function
  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  // Filter and sort the incentiveList
  const filteredRequests = incentiveList.filter((request) => {
    if (filterStatus === "all") return true;
    return request.status.toLowerCase() === filterStatus.toLowerCase();
  });

  // Apply sorting
  const sortedRequests = [...filteredRequests].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === "asc" ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === "asc" ? 1 : -1;
    }
    return 0;
  });

  const totalPages = Math.ceil(sortedRequests.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedRequests = sortedRequests.slice(startIndex, endIndex);

  const convertToCSV = (data) => {
    const headers = [
      "S.No",
      "Employee Name",
      "Employee ID",
      "Wallet Balance",
      "Requested Amount",
      "Request Date",
      "Status",
    ];

    const rows = data.map((request, index) => [
      index + 1,
      request.employeeName,
      request.employeeId,
      request.TotalAmount,
      request.withdrawAmount,
      request.requestDate.split("T")[0],
      request.status,
    ]);

    return [headers.join(","), ...rows.map((row) => row.join(","))].join("\n");
  };

  const handleDownload = () => {
    const csvData = convertToCSV(sortedRequests);
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "employee_withdrawals.csv";
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Base>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "300px" }}>
          <ClipLoader color="darkslategrey" size={50} />
        </div>
      ) : error ? (
        <div>{error}</div>
      ) : (
        <>
          <div className="pt-3 mt-5 addarea_labels pr-3">
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              <Link
                underline="hover"
                key="1"
                color="inherit"
                href="/admin/dashboard"
                sx={{ color: "darkslategrey", fontWeight: "bold" }}
              >
                Dashboard
              </Link>
              <Link
                underline="hover"
                key="3"
                color="inherit"
                href="/admin/admin_employee_walletwithdraw_requests"
                sx={{ color: "darkslategrey", fontWeight: "bold" }}
              >
                Employee Wallet Withdrawal Requests
              </Link>
            </Breadcrumbs>
          </div>

          <p className="text-center fw-bold main_heading mb-1">
            Employee Wallet Withdrawal Requests
          </p>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <hr style={{ width: "90%" }} />
          </div>

          <div className="employee-withdraw-container">
            {/* Filter Dropdown */}
            <div className="filter-container">
              <label htmlFor="status-filter">Filter by Status: </label>
              <select
                id="status-filter"
                value={filterStatus}
                onChange={(e) => {
                  setFilterStatus(e.target.value);
                  setCurrentPage(1); // Reset to first page when filter changes
                }}
              >
                <option value="all">All</option>
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>

              <button onClick={handleDownload} className="download-button-withdraw">
                Download Excel
              </button>
            </div>

            <Table className="responsive-table-wallet">
              <Thead>
                <Tr>
                  <Th onClick={() => requestSort("sno")}>S.No</Th>
                  <Th onClick={() => requestSort("employeeName")}>Employee Name</Th>
                  <Th onClick={() => requestSort("employeeId")}>Employee ID</Th>
                  <Th onClick={() => requestSort("TotalAmount")}>Wallet Balance</Th>
                  <Th onClick={() => requestSort("withdrawAmount")}>Requested Amount</Th>
                  <Th onClick={() => requestSort("requestDate")}>Request Date</Th>
                  <Th onClick={() => requestSort("status")}>Status</Th>
                  <Th>Actions</Th>
                </Tr>
              </Thead>
              <Tbody className="emp_w_rew_tb">
                {paginatedRequests.map((request, index) => (
                  <Tr key={request.id}>
                    <Td>{startIndex + index + 1}</Td>
                    <Td>{request.employeeName}</Td>
                    <Td>{request.employeeId}</Td>
                    <Td>{request.TotalAmount}</Td>
                    <Td>{request.withdrawAmount}</Td>
                    <Td>{request.requestDate.split("T")[0]}</Td>
                    <Td>
                      <span className={`status-badge ${request.status.toLowerCase()}`}>
                        {request.status}
                      </span>
                    </Td>
                    <Td className="req_withdraw_action_columm">
                      {request.status === "PENDING" && (
                        <>
                          <button
                            className="action-button approve"
                            onClick={() => handleApprove(request.transactionId)}
                          >
                            APPROVE
                          </button>
                          <button
                            className="action-button reject"
                            onClick={() => handleReject(request.transactionId)}
                          >
                            REJECT
                          </button>
                        </>
                      )}
                      {request.status !== "PENDING" && (
                        <span className="text-muted">No actions</span>
                      )}
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>

            <div className="pagination-controls-withdraw">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span className="mx-2">
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        </>
      )}
    </Base>
  );
};

export default EmployeeWalletWithdrawrequest;